import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import {Context} from "../Repository";

export default class Base extends React.Component {

  static contextType = Context;

  constructor(props) {
    super(props);

    this.state = {
      isOpen: props.defaultOpen,
      id:     shortid.generate()
    };

  }

  componentDidMount() {
    if (this.repository && this.name) {
      this.repository.register(this.name, this);
    }

    if (this.props.defaultOpen === true) {
      this.open();
    }
  }

  componentWillUnmount() {
    if (this.repository && this.name) {
      this.repository.unregister(this.name);
    }
  }

  /////////////////////////////////
  // Hooks
  /////////////////////////////////

  onOpen = () => {
    if (typeof this.props.handleOpen === 'function') {
      this.props.handleOpen();
    }
  };

  onClose = () => {
    if (typeof this.props.handleClose === 'function') {
      this.props.handleClose();
    }
  };

  /////////////////////////////////
  // Getters
  /////////////////////////////////

  get repository() {
    return this.context;
  }

  get name() {
    return this.props.name;
  }

  get isOpen() {
    return this.state.isOpen;
  }

  get isCloseable() {
    return this.props.closeable;
  }

  get baseClassName() {
    return 'modal';
  }

  get uniqueClass() {
    return 'modal-id-' + this.state.id;
  }

  /////////////////////////////////
  // Methods
  /////////////////////////////////

  removeActiveClass() {
    let elements = document.getElementsByClassName(this.uniqueClass);
    if (elements.length > 0) {
      for (let i = 0; i < elements.length; i++) {
        elements[i].className = elements[i].className.split('active').join(' ');
      }
    }
  }

  addActiveClass() {
    let elements = document.getElementsByClassName(this.uniqueClass);
    if (elements.length > 0) {
      for (let i = 0; i < elements.length; i++) {
        elements[i].className = elements[i].className + ' active';
      }
    }
  }

  resetTimeouts() {

    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }

    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

  }

  performOpen(callback) {
    this.removeActiveClass();
    this.setState({isOpen: true, id: shortid.generate()}, () => {
      this.onOpen();

      setTimeout(() => {
        this.addActiveClass();
          if (typeof callback === 'function') {
              callback();
          }
      }, 10);
    });
  }

  performClose(delay, callback) {
    this.removeActiveClass();

    this.closeTimeout = setTimeout(() => {
      this.setState({isOpen: false}, () => {
        this.onClose();
        this.resetTimeouts();
        if (typeof callback === 'function') {
          callback();
        }
      });
    }, delay);
  }

  open() {
      return new Promise((resolve, reject) => {

          this.resetTimeouts();
          this.performOpen(() => {
              resolve();
          });

      });
  }

  close(force = false, delay = 0) {
      return new Promise((resolve, reject) => {

          this.resetTimeouts();

          if (force === true || this.isCloseable) {
              this.performClose(delay, () => {
                  resolve();
              });
          }

      });
  }

  handleClose(e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.close();
  }

  handleModalClick(e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }

  /////////////////////////////////
  // Rendering
  /////////////////////////////////

  renderHeader() {

  }

  renderBody() {
    return this.props.children;
  }

  renderFooter() {
  }

  renderOverlay() {
    return (
      <div className='modal-overlay' onClick={this.handleClose.bind(this)}/>
    );
  }

  renderContent() {

    const className = [
      this.baseClassName,
      this.uniqueClass,
      this.className
    ].join(' ');

    return (
      <div className={className}>
        {this.renderHeader()}
        <div className='modal-content'>{this.renderBody()}</div>
        {this.renderFooter()}
      </div>
    );
  }

  renderModal() {

    if (this.isOpen === false) {
      return <div/>;
    }

    return (
      <div className={'modal-container ' + this.uniqueClass} onClick={this.handleModalClick.bind(this)}>
        {this.renderOverlay()}
        {this.renderContent()}
      </div>
    );
  }

  render() {
    return ReactDOM.createPortal(
      this.renderModal(),
      document.body
    );
  }

}

Base.propTypes = {
  children:    PropTypes.node,
  defaultOpen: PropTypes.bool,
  handleOpen:  PropTypes.func,
  handleClose: PropTypes.func,
  closeable:   PropTypes.bool,
  className:   PropTypes.string,
  name:        PropTypes.string,
};

Base.defaultProps = {
  defaultOpen: false,
  closeable:   true,
  name:        null,
};

